import React from 'react';
import Alert from 'react-bootstrap/Alert';
import styled from 'styled-components';


const ErrorForm = ({ mensaje, estadoAlerta }) => {
    return (
        <>
            {estadoAlerta &&
                <StyledAlert variant="danger" >
                    <p>{mensaje}</p>
                </StyledAlert>
            }

        </>

    );
}

const StyledAlert = styled(Alert)`

    margin-top: 0.5px !important;
    padding: 0% 0% 0% 5% !important;
    margin-bottom: -40px !important;
    

`;

export default ErrorForm;
